import { render, staticRenderFns } from "./SocailMediaPublished.vue?vue&type=template&id=134d2a30&scoped=true"
import script from "./SocailMediaPublished.vue?vue&type=script&lang=js"
export * from "./SocailMediaPublished.vue?vue&type=script&lang=js"
import style0 from "./SocailMediaPublished.vue?vue&type=style&index=0&id=134d2a30&prod&lang=sass&scoped=true"
import style1 from "./SocailMediaPublished.vue?vue&type=style&index=1&id=134d2a30&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "134d2a30",
  null
  
)

export default component.exports